import { render, staticRenderFns } from "./operationPartnerAmountAdjustRecord.vue?vue&type=template&id=1a749f2c&scoped=true"
import script from "./operationPartnerAmountAdjustRecord.vue?vue&type=script&lang=ts"
export * from "./operationPartnerAmountAdjustRecord.vue?vue&type=script&lang=ts"
import style0 from "./operationPartnerAmountAdjustRecord.vue?vue&type=style&index=0&id=1a749f2c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a749f2c",
  null
  
)

export default component.exports